var exports = {
  "x": "ExpiryFootnote.module__footnote___Y29yUU",
  "m": "ExpiryFootnote.module__inlineFootnote___Y29yUU",
};

module.exports = exports;
